/**
 * F2-a: guard route owner. Se non c'e' una sessione owner (UI-state),
 * redirige a /owner/login. L'auth "verita'" e' il cookie HttpOnly
 * `hm_owner_at` lato cloud: su 401 dal cloud, l'handler globale owner
 * (cloud-client.ts) pulisce questa session store e la guard riporta a login.
 */
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useOwnerSession } from '../../stores/owner.js';

export function RequireOwner({ children }: { children: ReactNode }) {
  const owner = useOwnerSession((s) => s.owner);
  if (!owner) return <Navigate to="/owner/login" replace />;
  return <>{children}</>;
}
